import { ColumnSetting } from '../../../_foundation/models/grid.models';

export const columns: ColumnSetting[] = [
  {
    field: 'activity',
    title: 'Activity',
    filter: 'text'
  },
  {
    field: 'dateShow',
    title: 'Date',
    filter: 'text'
  },
  {
    field: 'pinnedTimeShow',
    title: 'Pinned Time',
    filter: 'text'
  },

  {
    field: 'lastUpdatedTimeShow',
    title: 'Last Updated',
    filter: 'text'
  },
  {
    field: 'lastUpdatedBy',
    title: 'Last Updated By',
    filter: 'text'
  },
  {
    field: 'statusText',
    title: 'Status',
    filter: 'text'
  },
  {
    field: 'actions',
    title: '',
    filterable: false,
    width: 100
  }
];



// WEBPACK FOOTER //
// ./src/pages/validation/field-positioning-outstanding/field-positioning-outstanding-grid.config.ts